import { Controller } from "@hotwired/stimulus"

// The wizard's pets step. "Add another pet" and "Remove" change only the rows
// in the form; saving the step replaces the whole list. A ticked saved pet
// without a size shows its size row.
export default class extends Controller {
  static targets = ["list", "template", "row", "savedSize"]

  add() {
    // Keys only order the rows, so a timestamp keeps new ones last.
    const html = this.templateTarget.innerHTML.replaceAll("NEW_INDEX", Date.now())
    this.listTarget.insertAdjacentHTML("beforeend", html)
    this.rowTargets.at(-1).querySelector("input[type=text]")?.focus()
  }

  toggleSize({ target, params: { sizeRow } }) {
    const row = this.savedSizeTargets.find((element) => element.id === sizeRow)
    if (row) row.hidden = !target.checked
  }

  remove(event) {
    event.currentTarget.closest("[data-booking-wizard-pets-target='row']").remove()
    this.dispatch("removed")
  }
}
